<template>

  <div>
    <!-- Mensagem Usuário não logado -->
    <transition name="fade">
      <div id="mensagem-box"
           class="tw-w-full tw-cursor-pointer tw-text-center tw-px-2.5 tw-rounded-md tw-py-4 tw-font-new"
           :class="liberado ? 'tw-bg-jrGreen-200 tw-text-white' : 'tw-text-jrRed-50 tw-bg-white hover:tw-bg-jrRed-50 hover:tw-text-white'"
           @click="message.includes('condições de venda') ? openModalCondicoes() : null"
      >
        <i class="icon-warning tw-mr-3 tw-text-xs"></i><span v-html="message"></span><i class="icon-warning tw-ml-3 tw-text-xs"></i>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'MensagemBox',
  props: ['message','liberado'],
  methods: {
    alertHidden (ev) { // ESCONDER BOX DE ALERT ONLCLICK
      ev.currentTarget.parentNode.style = 'display:none;'
    },
    openModalCondicoes() {
      this.$parent.openModalCondicoes()
    }
  },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/MensagemBox.vue